export default {
    //权限接口
    GET_permissionsList: '/dqi-admanage/api.admin/v1/permissions',
    GET_permissionsDetail: '/dqi-admanage/api.admin/v1/permissions/',
    POST_permissionsAdd: '/dqi-admanage/api.admin/v1/permissions',
    DELETE_permissionsDel: '/dqi-admanage/api.admin/v1/permissions/',
    PUT_permissionsUpdate: '/dqi-admanage/api.admin/v1/permissions/',
    //用户接口
    GET_usersList: '/dqi-admanage/api.admin/v1/users',
    POST_usersAdd: '/dqi-admanage/api.admin/v1/users',
    GET_usersInfo: '/dqi-admanage/api.admin/v1/users/me',
    GET_usersName2Info: '/dqi-admanage/api.admin/v1/users/username/',
    DELETE_usersDel: '/dqi-admanage/api.admin/v1/users/',
    GET_usersDetail: '/dqi-admanage/api.admin/v1/users/',
    PUT_usersUpdate: '/dqi-admanage/api.admin/v1/users/',    //修改更新
    PATCH_adminUsersUpdate2: '/dqi-admanage/api.admin/v1/users/', //局部更新
    GET_sameRoletype: '/dqi-admanage/api.admin/v1/users/getUserByCoid/',//获取同企业的企业管理员
    //角色接口
    GET_roleIndex: '/dqi-admanage/api.admin/v1/roles',
    POST_roleAdd: '/dqi-admanage/api.admin/v1/roles',
    GET_roleList: '/dqi-admanage/api.admin/v1/roles/roleList',
    DELETE_roleDel: '/dqi-admanage/api.admin/v1/roles/',
    PUT_roleUpdate: '/dqi-admanage/api.admin/v1/roles/',//修改更新
    PATCH_rolePatch: '/dqi-admanage/api.admin/v1/roles/',//局部更新
    //部门接口
    POST_deptAdd: '/dqi-admanage/api.admin/v1/depts',
    GET_deptList: '/dqi-admanage/api.admin/v1/depts/list',
    GET_deptTree: '/dqi-admanage/api.admin/v1/depts/tree',
    DELETE_deptDelete : '/dqi-admanage/api.admin/v1/depts/',
    GET_deptDetail: '/dqi-admanage/api.admin/v1/depts/',
    PUT_deptUpdate: '/dqi-admanage/api.admin/v1/depts/',
    //菜单接口
    GET_menusList: '/dqi-admanage/api.admin/v1/menus', // 旧菜单
	GET_menuTest: '/dqi-admanage/api.admin/v1/menus/menuTest', // 新菜单

    POST_menusAdd: '/dqi-admanage/api.admin/v1/menus',
    GET_menusListAll: '/dqi-admanage/api.admin/v1/menus/all',
    DELETE_menusDelete: '/dqi-admanage/api.admin/v1/menus/',
    GET_menusDetail: '/dqi-admanage/api.admin/v1/menus/',
    PUT_menusUpdate: '/dqi-admanage/api.admin/v1/menus/', //修改更新
    PATCH_menusPatch: '/dqi-admanage/api.admin/v1/menus/',//局部更新

    POST_login: '/dqi-oamanage/oauth/token',   // 登录
    DELETE_logout: '/dqi-oamanage/oauth/logout',   // 退出登录
    GET_users: '/dqi-admin/api.admin/v1/users/me'  //获取个人信息
}



// WEBPACK FOOTER //
// ./src/http/apiModules/loginAPI.js